
import { Component, Vue, Prop } from 'vue-property-decorator';
import * as AnalysisRequestService from '@/modules/analysis/services/analysisRequestService';
import { RequestStatusEnum } from '@/modules/analysis/models/requestStatusEnum';

@Component({
  components: {}
})
export default class ArchiveRequestForm extends Vue {
  @Prop({ required: true })
  protected requestId!: string;
  protected sendingRequest = false;
  protected requestError = false;

  protected archiveRequest(): void {
    this.sendingRequest = true;
    setTimeout(() => {
      const statusBody = { status: RequestStatusEnum.ARCHIVED };
      AnalysisRequestService.updateStatus(this.requestId as string, statusBody)
        .then(() => {
          this.$emit('archive', this.requestId);
          this.$emit('close');
        })
        .catch(() => {
          this.requestError = true;
        })
        .finally(() => (this.sendingRequest = false));
    }, 500);
  }
}
